
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.16.2
 * Query Engine version: 4bc8b6e1b66cb932731fb1bdbbc550d1e010de81
 */
Prisma.prismaVersion = {
  client: "4.16.2",
  engine: "4bc8b6e1b66cb932731fb1bdbbc550d1e010de81"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  onboardingComplete: 'onboardingComplete',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  subscriptionId: 'subscriptionId',
  customerId: 'customerId',
  price: 'price',
  plan: 'plan',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  interval: 'interval',
  currency: 'currency',
  additionalVoiceSlots: 'additionalVoiceSlots',
  freeVoiceSlots: 'freeVoiceSlots',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  canceledAt: 'canceledAt',
  provider: 'provider',
  userId: 'userId'
};

exports.Prisma.ApiSubscriptionScalarFieldEnum = {
  subscriptionId: 'subscriptionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  customerId: 'customerId',
  status: 'status',
  billingQuota: 'billingQuota',
  userId: 'userId'
};

exports.Prisma.ApiKeyScalarFieldEnum = {
  id: 'id',
  label: 'label',
  apiKey: 'apiKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subscriptionId: 'subscriptionId'
};

exports.Prisma.ModelsScalarFieldEnum = {
  id: 'id',
  artist: 'artist',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  f0Method: 'f0Method',
  epochCount: 'epochCount',
  batchSize: 'batchSize',
  sampleRate: 'sampleRate',
  version: 'version',
  isPrivate: 'isPrivate',
  isClusterTrained: 'isClusterTrained',
  isLocked: 'isLocked',
  isCopyrightFree: 'isCopyrightFree',
  isInstrumental: 'isInstrumental',
  isCommunityModel: 'isCommunityModel',
  createdBy: 'createdBy',
  genre: 'genre',
  thumbnail: 'thumbnail',
  modelAId: 'modelAId',
  modelBId: 'modelBId',
  usageCount: 'usageCount',
  audioPreviewUrl: 'audioPreviewUrl',
  gender: 'gender',
  userId: 'userId',
  trendingUsageCount: 'trendingUsageCount'
};

exports.Prisma.FavoritedModelsScalarFieldEnum = {
  modelId: 'modelId',
  userId: 'userId'
};

exports.Prisma.AudioGenerationScalarFieldEnum = {
  id: 'id',
  audioId: 'audioId',
  filename: 'filename',
  displayName: 'displayName',
  type: 'type',
  isSaved: 'isSaved',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  modelId: 'modelId',
  status: 'status',
  userId: 'userId'
};

exports.Prisma.MusicGenerationScalarFieldEnum = {
  id: 'id',
  prompt: 'prompt',
  duration: 'duration',
  userId: 'userId',
  filename: 'filename',
  displayName: 'displayName',
  status: 'status',
  isSaved: 'isSaved',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StemGenerationScalarFieldEnum = {
  id: 'id',
  audioId: 'audioId',
  generationId: 'generationId',
  bucket: 'bucket',
  audioPath: 'audioPath',
  path: 'path',
  filename: 'filename',
  displayName: 'displayName',
  type: 'type',
  isSaved: 'isSaved',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  userId: 'userId'
};

exports.Prisma.ModelDatasetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  modelId: 'modelId',
  quality: 'quality',
  path: 'path',
  userId: 'userId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.SubscriptionPlans = {
  free: 'free',
  starter: 'starter',
  pro: 'pro',
  studio: 'studio',
  label: 'label'
};

exports.SubscriptionStatus = {
  active: 'active',
  canceled: 'canceled',
  past_due: 'past_due',
  paused: 'paused',
  trialing: 'trialing'
};

exports.SubscriptionIntervals = {
  month: 'month',
  year: 'year'
};

exports.SubscriptionProvider = {
  stripe: 'stripe',
  paddle: 'paddle'
};

exports.ModelStatusTypes = {
  pending: 'pending',
  training: 'training',
  completed: 'completed',
  failed: 'failed'
};

exports.GenerationStatusTypes = {
  completed: 'completed',
  processing: 'processing',
  failed: 'failed'
};

exports.Prisma.ModelName = {
  Account: 'Account',
  User: 'User',
  VerificationToken: 'VerificationToken',
  Subscription: 'Subscription',
  ApiSubscription: 'ApiSubscription',
  ApiKey: 'ApiKey',
  Models: 'Models',
  FavoritedModels: 'FavoritedModels',
  AudioGeneration: 'AudioGeneration',
  MusicGeneration: 'MusicGeneration',
  StemGeneration: 'StemGeneration',
  ModelDataset: 'ModelDataset'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
